







































import { Component, Prop, Vue, Provide, Watch } from "vue-property-decorator";
import SearchResultItem from "@/components/SearchResultItem.vue";

@Component({
  components: {
    SearchResultItem
  }
})
export default class SearchResultGroupedItem extends Vue {
  @Prop() private item!: any;

  private productTaxcodes = ["P", "D"];
  private serviceTaxcodes = ["S"];
  private otherTaxcodes = ["O"];

  get isSearch() {
    return this.$route.query.q && this.$route.query.q !== "";
  }

  get itemLink() {
    return {};
  }

  highlightedResult() {
    return Array.from(this.item.results.values()).find(
      (x: any) => x.resultType !== "Tree" && x.resultInclude
    );
  }

  additionalResults() {
    return Array.from(this.item.results.entries()).filter(
      (x: any) => !x[1].resultInclude
    );
  }

  treeClassification(taxcodes: Array<string>) {
    const taxcodeTypes = new Set(
      taxcodes.map(t => {
        if (this.productTaxcodes.includes(t[0])) return "Goods";
        else if (this.serviceTaxcodes.includes(t[0])) return "Services";
        else return "Goods and services";
      })
    );

    if (taxcodeTypes.size === 1) {
      return taxcodeTypes.values().next().value;
    }

    return "Goods and services";
  }

  onSelectTree() {
    if (this.$store.getters.analyticsEnabled) {
      window._satellite.track("interactive_session");
    }
  }
}
